import { axiosInstance } from '../../../../services/axios-instance';

export const stores = {
  getStoresByStateCity: (state: string, city: string) => {
    const type = 2;
    return axiosInstance
      .get('/user', { params: { state, city, type } })
      .then(res => {
        return res.data;
      })
      .catch(err => console.error(err));
  },

  getStoresByStateCitySearch: (state: string, city: string) => {
    const type = 2;
    return axiosInstance
      .get('/user/find', { params: { state, city, type } })
      .then(res => {
        return res.data;
      })
      .catch(err => console.error(err));
  },
};
